

































































































































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { VbTooltipSlot } from '@/shared/slots/tooltip-slot.component.vue';
import routeTo from '@/router/routeTo'
import DateHandler from '@/shared/utils/date-format';
import splitContent from '@/shared/directive/split-content';
import toDocument from '@/shared/directive/toDocument';
import toCurrency from '@/shared/directive/toCurrency';

@Component({
  components: {
    VbTooltipSlot,
  },
  filters: {
    formatDate(value: string) {
      return DateHandler.timestampToLocal(value);
    },
    convertDate(value: string) {
      return DateHandler.fullMonthAndYear(value);
    },
    toCurrency,
    toDocument,
    splitContent,
  },
})

export default class BillingDataRow extends Vue {
  @Prop({ required: true }) header!: any;

  @Prop({ required: true }) item!: any;

  @Prop({ required: true }) isAdministrator!: boolean;

  @Prop({ default: '' }) readonly businessUnitId!: string;

  currencyFormat: any = toCurrency;

  getClass() {
    let classes = 'table__column'
    classes += this.item.isUnpaid ? ' unpaid' : ''
    classes += !this.headerNotClicked() ? ' clickable' : ''
    return classes;
  }

  isDisabled(): boolean {
    return !this.isAdministrator
      || !this.item.isPreInvoice
      || this.item.deleted;
  }

  displayColumn(columnName: string): boolean {
    return this.header.value === columnName
      && this.header.active;
  }

  removeButtonTooltipText(): string {
    if (this.item.deleted) {
      return 'Remoção Pendente';
    }
    if (!this.isAdministrator) {
      return 'Você não tem permissão para remover um faturamento'
    }
    if (this.item.isPreInvoice) {
      return 'Remover faturamento'
    }
    return 'Só é possível remover faturamentos com status Pré-Faturado';
  }

  goToBillingInfoView(): void {
    if (this.item.deleted) return;
    if (this.headerNotClicked()) return;
    const route: any = {
      name: 'FaturamentoInfo',
      params: {
        billingId: this.item.id,
        businessUnitId: this.businessUnitId,
      },
    };
    routeTo(this.$router, route)
  }

  headerNotClicked(): boolean {
    const headerNotClicked = ['selected', 'deleted', 'actions']
    return headerNotClicked.includes(this.header.value)
  }

  setDeleteBillingId() {
    this.$emit('click-remove', this.item.id);
  }
}
